import api from './api';

export class AddressService {
    static async getSuggestionsForAddress(metadata = {}, address) {
        const { userId } = metadata;

        let suggestions = {};
        try {
            suggestions = await api.getAddressSuggestions(userId, address);
        } catch (error) {
            suggestions.error = error;
        }

        return suggestions;
    }
}
